import { Injectable } from '@angular/core';
import { features, routes } from '@app/consts';
import { modules } from '@app/consts/modules';

@Injectable({
  providedIn: 'root'
})
export class SiteSettingsService {
  menuItems = [
    {
      text: 'OrganizationStructure',
      detail: 'OrganizationStructure-Description',
      link: `${routes.SITE_SETTINGS}${routes.ORGANIZATION}`,
      icon: 'domain',
      featureCode: features.ORGANIZATION
    },
    {
      text: 'Positions',
      detail: 'Positions-Description',
      link: `${routes.SITE_SETTINGS}${routes.POSITIONS}`,
      icon: 'badge',
      featureCode: 'Positions'
    },
    {
      text: 'CostCenters',
      detail: 'CostCenters-Description',
      link: `${routes.SITE_SETTINGS}${routes.COST_CENTERS}`,
      icon: 'attach_money',
      featureCode: features.COST_CENTERS
    },
    {
      text: 'Lists',
      detail: 'Lists-Description',
      link: `${routes.SITE_SETTINGS}${routes.LISTS}`,
      icon: 'edit_note',
      featureCode: 'Lists'
    },
    {
      text: 'tbl_WorkLocations',
      detail: 'tbl_WorkLocations-Description',
      link: `${routes.SITE_SETTINGS}${routes.WORK_LOCATIONS}`,
      icon: 'home_work',
      featureCode: 'WorkLocations'
    },
    {
      text: 'WorkRotations',
      detail: 'WorkRotations-Description',
      link: `${routes.SITE_SETTINGS}${routes.WORK_ROTATIONS}`,
      icon: 'pending_actions',
      featureCode: 'WorkRotations',
      module: modules.TIME_OFF
    },
    {
      text: 'Forms',
      detail: 'Forms-Description',
      link: `${routes.SITE_SETTINGS}${routes.FORMS}`,
      icon: 'library_books',
      featureCode: 'Forms'
    },
    {
      text: 'Configure',
      detail: 'Configure-Description',
      link: `${routes.SITE_SETTINGS}${routes.CONFIGURE}`,
      icon: 'settings',
      featureCode: features.SITE_SETTINGS
    },
    {
      text: 'Currency',
      detail: 'Currency-Description',
      link: `${routes.SITE_SETTINGS}${routes.CURRENCY}`,
      icon: 'attach_money',
      featureCode: 'Currency'
    },
    {
      text: 'Translations',
      detail: 'Translations-Description',
      link: `${routes.SITE_SETTINGS}${routes.TRANSLATIONS}`,
      icon: 'translate',
      featureCode: features.GLOBALIZATION
    },
    {
      text: 'CountryConfig',
      detail: 'CountryConfig-Description',
      link: `${routes.SITE_SETTINGS}${routes.COUNTRY_CONFIG}`,
      icon: 'public',
      featureCode: features.COUNTRY_CONFIG
    },
    {
      text: 'SchedulesAdministration',
      detail: 'SchedulesAdministration-Description',
      link: `${routes.SITE_SETTINGS}${routes.GENERATE_SCHEDULE}`,
      icon: 'calendar_month',
      featureCode: features.SCHEDULES,
      module: modules.TIME_OFF
    },
    {
      text: 'TableFieldEditor',
      detail: 'TableFieldEditor-Description',
      link: `${routes.SITE_SETTINGS}${routes.TABLE_FIELD_EDITOR}`,
      icon: 'edit_note',
      featureCode: 'allow'
    },
    {
      text: 'BusinessRuleAutomation',
      detail: 'BusinessRuleAutomation-Description',
      link: `${routes.SITE_SETTINGS}${routes.BUSINESS_RULE_AUTOMATION}`,
      icon: 'mark_email_unread',
      featureCode: features.BUSINESS_RULE_AUTOMATION,
      module: modules.BUSINESS_RULE_AUTOMATION
    },
    {
      text: 'Styling',
      detail: 'Styling-Description',
      link: `${routes.SITE_SETTINGS}${routes.STYLING}`,
      icon: 'style',
      featureCode: features.SITE_STYLING
    },
    {
      text: 'Integrations',
      detail: 'Integrations-Description',
      link: `${routes.SITE_SETTINGS}${routes.INTEGRATIONS}`,
      icon: 'hub',
      featureCode: features.INTEGRATIONS
    },
    {
      text: 'QuickLinks',
      detail: 'QuickLinks-Description',
      link: `${routes.SITE_SETTINGS}${routes.QUICK_LINKS}`,
      icon: 'link',
      featureCode: features.QUICK_LINKS
    },
    {
      text: 'Articles',
      detail: 'Articles-Description',
      link: `${routes.SITE_SETTINGS}${routes.ARTICLES}`,
      icon: 'campaign',
      featureCode: features.ARTICLES
    },
  ]

  constructor() { }

  get MenuItems() {
    return this.menuItems.map(item => {
      return {
        ...item,
        featureCode: item.featureCode || 'allow',
        module: item.module || null,
        detail: item.detail || `${item.text}-Description`
      };
    });
  }
}
